//流动线材质
function PolylineTrailLinkMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined;
    this._colorSubscription = undefined;
    this._time = new Date().getTime();

    this.color = options.color;
    this.duration = options.duration;
    this.image = options.image;
}

Object.defineProperties(PolylineTrailLinkMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color')
});

PolylineTrailLinkMaterialProperty.prototype.getType = function (time) {
    return Cesium.Material.PolylineTrailType;
};

PolylineTrailLinkMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    result.color = Cesium.Property.getValueOrClonedDefault(
        this._color,
        time,
        Cesium.Color.WHITE,
        result.color
    );
    result.image = this.image || Cesium.Material.DefaultImagePolylineTrailType;
    result.time = ((new Date().getTime() - this._time) % this.duration) / this.duration;
    return result;
};

PolylineTrailLinkMaterialProperty.prototype.equals = function (other) {
    return (
        this === other
    );
};
export default PolylineTrailLinkMaterialProperty;